import React from 'react';

import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  AppStoreBadgeIcon,
  GooglePlayBadgeIcon,
  HubmeeLogoWithLetterHorizontal,
} from '@setup/svg-icons/svg-icons';
import { MuiLink } from '@shared/ui-kit';

import {
  ContactSupportContainer,
  Container,
  DownloadLinkContainer,
  DownloadLinkWrapper,
  LogoWrapper,
  SupportText,
  UseHubmeeAppContainer,
  UseHubmeeAppSubtitle,
  UseHubmeeAppTitle,
} from './MaintenanceMobileStub.style';

const HUBMEE_PROMO_LINK = 'https://hubmee.com';
const support_link = 'mailto:support@hubmee.com';

const GOOGLE_PLAY_LINK = 'https://play.google.com/store/apps/details?id=com.hubmee.app';
const APP_STORE_LINK = 'https://apps.apple.com/us/app/hubmee/id1357144691';

export const MaintenanceMobileStub = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <LogoWrapper>
        <MuiLink to={HUBMEE_PROMO_LINK} target="_self">
          <HubmeeLogoWithLetterHorizontal />
        </MuiLink>
      </LogoWrapper>

      <Box mt="72px">
        <UseHubmeeAppContainer>
          <UseHubmeeAppTitle variant="s1">{t('stubs.maintenanceStubMobile.app')}</UseHubmeeAppTitle>
          <UseHubmeeAppSubtitle variant="t14r">
            {t('stubs.maintenanceStubMobile.our_services')}
          </UseHubmeeAppSubtitle>
        </UseHubmeeAppContainer>

        <DownloadLinkContainer>
          <Typography textAlign="center" variant="t14r" color={(theme) => theme.palette.case.neutral.n700}>
            {t('stubs.maintenanceStubMobile.download_app')}
          </Typography>

          <DownloadLinkWrapper>
            <MuiLink to={APP_STORE_LINK} target="_self">
              <AppStoreBadgeIcon />
            </MuiLink>

            <MuiLink to={GOOGLE_PLAY_LINK} target="_self">
              <GooglePlayBadgeIcon />
            </MuiLink>
          </DownloadLinkWrapper>
        </DownloadLinkContainer>
      </Box>

      <ContactSupportContainer>
        <SupportText variant="t12r">{t('stubs.maintenanceStubMobile.support_text')}</SupportText>

        <MuiLink to={support_link} variantLink="blue" target="_blank">
          {t('general.buttons.contactSupport')}
        </MuiLink>
      </ContactSupportContainer>
    </Container>
  );
};
